import React from "react";

function CookiePolicy() {
  return (
    <div>
      <div>CookiePolicy</div>
    </div>
  );
}

export default CookiePolicy;
